import { colorsPalettes } from "@similarweb/styles";
import { CenteredFlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { contentWrapperBaseStyles } from "../../styles";

export const StyledTitleItem = styled(FlexRow)`
    column-gap: 12px;
    height: 44px;
`;

export const StyledResultsLoaderRow = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box;

    &:not(:last-child) {
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
`;

export const StyledView = styled(CenteredFlexColumn)`
    ${contentWrapperBaseStyles};

    align-items: flex-start;
    height: 100%;
    padding: 8px 24px;
    box-sizing: border-box;
`;
